import grapesjs from 'drapcode-builder';
import loadComponents from './components';
import loadBlocks from './blocks';
import { marketPlaceFormRef } from './consts';

export default grapesjs.plugins.add('gjs-marketplace-form', (editor, opts) => {
  let c = opts || {};

  let defaults = {
    pfx: 'market-place-form',
    blocks: [marketPlaceFormRef],
    defaultStyle: true,
    labelMarketplaceFormCategory: 'Shopping',
    labelMarketplaceForm: 'Marketplace',
  };

  for (let name in defaults) {
    if (!(name in c)) c[name] = defaults[name];
  }

  loadComponents(editor, c);
  loadBlocks(editor, c);
});
